<template>
  <div
    ref="target"
    class="
      relative
      px-4
      text-whitebase text-xs
      flex
      items-center
      border border-pass-topbg
      md:border-transparent
      rounded-lg
      bg-transparent
      md:bg-white-005
      flex-1
      min-w-0
    "
    style="height: 40px"
  >
    <input
      v-model="state.word"
      class="
        w-full
        h-full
        text-xs
        py-1
        bg-transparent
        border-0
        px-0
        contract-search
      "
      type="text"
      placeholder="Search project and contract"
      @focus="state.focus = true"
    />
    <div
      v-if="state.word != ''"
      class="
        absolute
        w-4
        h-4
        rounded-full
        flex
        items-center
        justify-center
        cursor-pointer
        right-10
      "
      @click="state.word = ''"
    >
      <i class="iconfont icon-guanbi text-xs"></i>
    </div>
    <i
      class="iconfont icon-sousuo1"
      style="color: rgba(255, 255, 255, 0.4)"
    ></i>

    <div
      class="
        absolute
        -bottom-2
        left-0
        transform
        translate-y-full
        py-2
        px-4
        w-full
        rounded-sm
        z-20
      "
      style="background: #2a2e33ff"
      v-if="state.word && state.focus"
    >
      <div v-if="loading" class="flex items-center justify-center h-4">
        <Spin></Spin>
      </div>

      <div v-else>
        <!-- address -->
        <div v-if="isAddress">
          <div
            v-for="(chain, i) in state.result"
            :key="i"
            class="flex items-center cursor-pointer item-hover rounded-sm p-2"
            @click="onSelect(i, 'address')"
          >
            <ChainCell :chain="chain"> </ChainCell>
            <span class="ml-2"> {{ state.word }} </span>
          </div>

          <div v-if="state.result.length == 0">No items found</div>
        </div>
        <!-- nft & project -->
        <div v-else class="overflow-scroll" style="max-height: 256px">
          <div v-if="state.result.nftTable.length > 0">
            <div
              class="font-bold flex items-center h-10 mb-2"
              style="border-bottom: 1px solid #ffffff26"
            >
              Porject
            </div>
            <div>
              <div
                class="hover:bg-white-005 py-2 cursor-pointer"
                v-for="(item, i) in state.result.nftTable"
                :key="i"
                @click="onSelect(i)"
              >
                <NameCell :item="item" :jumpPath="false"></NameCell>
              </div>
            </div>
          </div>
          <div v-if="state.result.nftCard.length > 0">
            <div
              class="font-bold flex items-center h-10 mb-2"
              style="border-bottom: 1px solid #ffffff26"
            >
              NFT Item
            </div>
            <div>
              <div
                class="
                  flex
                  items-center
                  px-4
                  hover:bg-white-005
                  py-2
                  cursor-pointer
                "
                v-for="(item, i) in state.result.nftCard"
                :key="i"
                @click="onSelect(i, 'nft')"
              >
                <UiImg
                  class="w-10 h-10 rounded overflow-hidden mr-2 flex-shrink-0"
                  :src="item.imageUrl"
                ></UiImg>
                <div>
                  <div class="font-bold" style="color: #268cffff">
                    {{ item.name }}
                  </div>
                  <ChainCell :chain="item.network"></ChainCell>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              state.result.nftTable.length == 0 &&
              state.result.nftCard.length == 0
            "
          >
            No items found
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, defineProps, watch, defineEmits, ref, computed } from 'vue';
import {
  queryDashbaordByContractAddress,
  dashboardSearchNft,
  getDaoIdByPath,
} from '@/api/dao';
import ChainCell from './ChainCell.vue';
import Spin from '@/components/Spin.vue';
import { useReq } from '@/hooks';
import { onClickOutside } from '@vueuse/core';
import { utils } from 'ethers';
import NameCell from './NameCell.vue';
import UiImg from '@/components/UiImg.vue';
import { CopyJson } from '@/utils';
import { useRoute } from 'vue-router';

const target = ref(null);
const $emits = defineEmits(['search']);
const $route = useRoute();

const isAddress = computed(() => utils.isAddress(state.word));

const state = reactive({
  word: '',
  result: [],
  focus: false,
});

const { loading: loadingAddress, loadData } = useReq(async () => {
  const prev = isAddress.value;
  const res = await queryDashbaordByContractAddress(
    await getDaoIdByPath($route.params.name),
    state.word,
    true,
  );
  if (prev == isAddress.value) state.result = res;
});

const { loadData: searchNft, loading: loadingProject } = useReq(async () => {
  const prev = isAddress.value;
  const res = await dashboardSearchNft(
    await getDaoIdByPath($route.params.name),
    state.word,
    true,
  );
  if (prev == isAddress.value) state.result = res;
});

const loading = computed(() => {
  return isAddress.value ? loadingAddress.value : loadingProject.value;
});

const onSelect = (i, type) => {
  state.focus = false;

  let conf = {};

  if (type == 'address') {
    conf = {
      isAddress: isAddress.value,
      value: {
        address: state.word,
        chain: state.result[i],
      },
    };
  } else if (type == 'nft') {
    conf = {
      isNft: true,
      value: CopyJson(state.result.nftCard[i]),
    };
  } else {
    conf = {
      isProject: true,
      value: CopyJson(state.result.nftTable[i]),
    };
  }

  $emits('search', conf);
};

watch(
  () => state.word,
  async (val) => {
    if (val != '') {
      isAddress.value ? loadData() : searchNft();
    } else {
      $emits('search', null);
    }
  },
);

onClickOutside(target, (event) => {
  state.focus = false;
});
</script>

<style scoped>
.item-hover:hover {
  background: #ffffff0d;
}
.contract-search::-webkit-input-placeholder {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.4);
}
</style>
